import { Grid, Box } from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
// import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState, useCallback } from "react";
import { getLawsuitsFailure } from "../../services/LawsuitService";
import DatagridCustom from "../General/DatagridCustom";
import { useToast } from "../../context/ToastContext";

export default function ManagerLawsuitFailure() {
  const { showToast } = useToast();
  const [lawsuitFailure, setLawsuitFailure] = useState([]);
  // const [openSuccess, setOpenSuccess] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });

  const fetchLawsuitFailure = useCallback(async () => {
    setLoading(true);
    try {
      const { page, pageSize } = paginationModel;
      const searchTerm = filterModel.quickFilterValues?.join(" ") || "";

      const res = await getLawsuitsFailure({
        page: page + 1,
        perPage: pageSize,
        search: searchTerm,
      });

      setLawsuitFailure(res.data.data);
      setTotal(res.data.total);
    } catch (error) {
      console.error("[ManagerLawsuitFailure] Error al cargar datos:", error);
      showToast(
        "No se pudieron cargar los datos. Intente de nuevo más tarde.",
      "error")
    } finally {
      setLoading(false);
    }
  }, [paginationModel, filterModel, showToast]);

  useEffect(() => {
    fetchLawsuitFailure();
  }, [paginationModel, filterModel, fetchLawsuitFailure]);

  const handleFilterModelChange = useCallback(
    (newFilterModel) => {
      const currentSearchTerm = filterModel.quickFilterValues?.join(" ") || "";
      const newSearchTerm = newFilterModel.quickFilterValues?.join(" ") || "";

      setFilterModel(newFilterModel);

      if (currentSearchTerm !== newSearchTerm) {
        setPaginationModel((prev) =>
          prev.page !== 0 ? { ...prev, page: 0 } : prev,
        );
      }
    },
    [filterModel],
  );

  const columns = [
    {
      field: "updated_at",
      headerName: "Fecha de Actualización",
      flex: 1,
      valueGetter: (params) => {
        const date = new Date(params);

        if (isNaN(date.getTime())) {
          return "Fecha inválida";
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes}`;
      },
    },
    { field: "original_name", headerName: "Nombre del Archivo" },
    { field: "reason", headerName: "Razón", flex: 1 },
    {
      field: "context",
      headerName: "Contexto",
      flex: 1,
      valueGetter: (params) => {
        if (!params) return "";
        try {
          return JSON.stringify(params, null, 2); // lo convierte en string legible
        } catch (e) {
          return "";
        }
      },
    },
    {
      field: "lawyers",
      headerName: "Abogado",
      flex: 1.2,
      valueGetter: (params) => {
        const l = params;
        if (!l) return "";
        const name = [l.name, l.lastname].filter(Boolean).join(" ");
        return l.enrollment ? `${name} (${l.enrollment})` : name;
      },
    },
  ];

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>

        {/* <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}> */}
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <DatagridCustom
            rows={lawsuitFailure}
            columns={columns}
            title="Listado de Archivos Fallidos"
            description="Visualice los archivos y títulos que no se cargaron automaticamente."
            icon={<AssignmentIcon sx={{ fontSize: 32 }} />}
            // error={globalError}
            // success={success}
            paginationModel={paginationModel}
            onPaginationChange={setPaginationModel}
            total={total}
            loading={loading}
            filterModel={filterModel}
            onFilterChange={handleFilterModelChange}
            filterMode="server"
            isServerPagination={true}
          />
        </Box>
        {/* </Paper> */}
      </Grid>

      
    </Grid>
  );
}
